"use strict";const s=require("./isObjectLike-e31ae33c.js");var b=s._baseGetTag,i=s.isObjectLike_1,t="[object Symbol]";function o(e){return typeof e=="symbol"||i(e)&&b(e)==t}var r=o;exports.isSymbol_1=r;
